let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bmRjE"), load("jrkFV"), load("gZKQW"), load("4Oj5y"), load("7rEYM"), load("ipK41"), load("eK94l")]).then(() => parcelRequire('8fb5x'));